import { PageLogin } from '@/components/login/page-login';
import { redirectionSure } from '@/lib/garde-session';
import { rechercheLoginSchema } from '@/lib/params-recherche';
import { lireSession } from '@/lib/session';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/login')({
  validateSearch: (recherche) => rechercheLoginSchema.parse(recherche),
  // A visitor who already holds a valid session has nothing to do here: on to the page asked for.
  beforeLoad: ({ search }) => {
    if (lireSession() !== null) throw redirect({ href: redirectionSure(search.redirection) });
  },
  component: LoginPage,
});

/**
 * `/login`: once signed in, back to the page that was asked for (B5, #13), the input screen
 * otherwise; "Votre session a expiré" when the user was sent here by an expired session.
 */
function LoginPage() {
  const navigate = useNavigate();
  const { redirection, motif } = Route.useSearch();
  return (
    <PageLogin
      sessionExpiree={motif === 'session-expiree'}
      onConnecte={() => {
        void navigate({ href: redirectionSure(redirection), replace: true });
      }}
    />
  );
}
